import * as yup from 'yup'

export const paymentSchema = yup.object().shape({
  amount: yup.number()
    .typeError('Enter an amount of at least $1.')
    .min(1, 'Enter an amount of at least $1.')
    .required('Enter an amount.'),
  name: yup.string().required('Enter the cardholder name.'),
  address: yup.string().required('Enter the billing street address.'),
  city: yup.string().required('Enter the billing city.'),
  state: yup.string().required('Enter the billing state.'),
  zipCode: yup.string()
    .matches(/^[0-9]{5}$/, 'Enter a 5-digit ZIP code.')
    .required('Enter the billing ZIP code.'),
  country: yup.string().required('Enter the billing country.'),
})
